import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { LocationService } from '../proxy/planning/controllers/location.service';
import { PropertyService } from '../proxy/planning/controllers/property.service';

FieldBuilder.setNamespace('Planning');

export const FENCE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.Fence.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
  FieldBuilder
    .number('gisFenceId', 'Entity.Fence.GISFence')
    .build(),
  FieldBuilder
    .foreignKey('propertyId', 'Entity.Property', PropertyService)
    .required()
    .displayFromNested('property.name')
    .sortBy('property.name')
    .build(),
  FieldBuilder
    .foreignKey('locationId', 'Entity.Location', LocationService)
    .required()
    .displayFromNested('location.name')
    .sortBy('location.name')
    .hideInChildForms()
    .build(),
];

export const FENCE_CONFIG = {
  entityName: 'Fence',
  localizationKey: 'Planning::Entity.Fence',
  permission: 'PlanningLocation.Fences',
  fields: FENCE_FIELDS,

  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Location + MENU_NAME_SUFFIX,
};
